import React from "react";
import LineItemCreditItem from "../../../Domain/CreditMemo/LineItemCreditItem";
import TabOfDataTable from "../../../Elements/DataTable/TabOfDataTable";
import ErrorMessage from "../../../Elements/ErrorMessage";
import Loading from "../../../Elements/loading";
import OrderDirectionsEnum from "../../../Enums/OrderDirectionsEnum";
import ShownPanelsEnum from "../../../Enums/ShownPanelsEnum";
import CreditMemoService from "../../../Services/CreditMemo/CreditMemoService";
import LineItemCreditService from "../../../Services/CreditMemo/LineItemCreditService";
import LineItemCreditSearchParams from "./LineItemCreditSearchParams";

export default class LineItemCreditTab extends React.Component {
  static defaultProps = {};

  dbService = LineItemCreditService;
  dbItem = LineItemCreditItem;
  creditMemoId = new URLSearchParams(window.location.search).get("id");

  constructor(props) {
    super(props);
    let searchParams = new LineItemCreditSearchParams();
    this.state = {
      loading: true,
      searchItem: searchParams,
      shownPanel: ShownPanelsEnum.None,
    };

    this.startSearch = this.startSearch.bind(this);
  }

  componentDidMount() {
    CreditMemoService.GetById(this.creditMemoId)
      .then((result) => {
        this.setState({
          searchItem: { ...this.state.searchItem, CreditMemoStatus: result.statusCode },
          loading: false,
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage("LICT40"));
  }

  startSearch(searchItem) {
    this.setState({ searchItem: searchItem });
  }

  render() {
    return this.state.loading ? (
      <Loading />
    ) : (
      <div className="contentwrapper">
        <TabOfDataTable
          type={this.dbItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={this.dbService.GetListBySearching}
          convertDBItemsFunction={this.dbService.ConvertDBItemList}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Desc}
          orderBy={"ApolloId"}
          showSearchStrip={true}
          searchParamsType={LineItemCreditSearchParams}
          clickOnStartSearch={this.startSearch}
          enableUrlPush={false}
          isFilterDisabled={this.state.searchItem.CreditMemoStatus === 2}
          errorCode="LICT66"
        />
      </div>
    );
  }
}
